import React from "react";

const SDG = () => {
	return (
		<section className="bg-white py-16 lg:py-20 px-6">
			<div className="container">
				{/* Top Section - Title and Intro */}
				<div className="text-left max-w-4xl mb-16">
					{/* Main Heading */}
					<h2 className="text-2xl lg:text-3xl xl:text-4xl font-light text-swift-pink leading-tight mb-6 font-generalSans">
						Core UN Sustainable Development Goals We Support At
						Swift Haven
					</h2>

					{/* Intro Paragraph */}
					<p className="text-l text-swift-dark font-light leading-relaxed font-generalSans">
						Swift Haven's mission is to empower girls and build
						healthier communities. Our innovative solutions are
						designed to align with and accelerate progress toward
						the UN Sustainable Development Goals:
					</p>
				</div>

				{/* Bottom Section - SDG Images Only */}
				<div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-5 gap-2">
					<img
						src="/assets/images/SDG-3.png"
						alt="SDG Goal 3"
						className="w-[12rem] h-[12rem] rounded-lg mx-auto object-contain hover:scale-105 hover:drop-shadow-lg transition-all duration-300 cursor-pointer"
					/>

					<img
						src="/assets/images/SDG-4.png"
						alt="SDG Goal 4"
						className="w-[12rem] h-[12rem] rounded-lg mx-auto object-contain hover:scale-105 hover:drop-shadow-lg transition-all duration-300 cursor-pointer"
					/>

					<img
						src="/assets/images/SDG-5.png"
						alt="SDG Goal 5"
						className="w-[12rem] h-[12rem] rounded-lg mx-auto object-contain hover:scale-105 hover:drop-shadow-lg transition-all duration-300 cursor-pointer"
					/>

					<img
						src="/assets/images/SDG-10.png"
						alt="SDG Goal 10"
						className="w-[12rem] h-[12rem] rounded-lg mx-auto object-contain hover:scale-105 hover:drop-shadow-lg transition-all duration-300 cursor-pointer"
					/>

					<img
						src="/assets/images/SDG-17.png"
						alt="SDG Goal 17"
						className="w-[12rem] h-[12rem] rounded-lg mx-auto object-contain hover:scale-105 hover:drop-shadow-lg transition-all duration-300 cursor-pointer"
					/>
				</div>
			</div>
		</section>
	);
};

export default SDG;
